import { inject, InjectionToken, isDevMode, DOCUMENT } from '@angular/core';

// mimic the breakpoints we configured in tailwind
export const screenSizes = [
  'xs',
  'sm',
  'md',
  'lg',
  'xl',
  '2xl',
  '3xl',
  '4xl',
  '5xl',
  '6xl',
  '7xl',
  '8xl',
  '9xl',
  '10xl'
] as const;
export type ScreenSize = typeof screenSizes[number];

export const TW_BREAKPOINTS = new InjectionToken('TW_BREAKPOINTS', {
  providedIn: 'root',
  factory: () => {
    const devMode = isDevMode();
    const document = inject(DOCUMENT);

    const styles = getComputedStyle(document.documentElement);

    const breakpoints = screenSizes.reduce((state, current) => {
      const container = styles.getPropertyValue(`--breakpoint-${current}`);
      if (container) {
        state[current] = container;
      }
      return state;
    }, {} as Record<ScreenSize, string>);

    if (devMode)
      console.debug(breakpoints);
    return breakpoints;
  }
});

export const TW_CSS = new InjectionToken<void>('TW_CSS', {
  providedIn: 'root',
  factory: () => {
    const document = inject(DOCUMENT);
    attachTailwindCss(document);
  }
});

export const attachTailwindCssGuard = () => inject(TW_CSS);

function attachTailwindCss(document: Document) {
  const file = 'tw.css';
  const exists = document.getElementById(file);
  if (exists)
    return;

  const el = document.createElement('link');
  el.id = file;
  el.rel = 'stylesheet';
  el.type = 'text/css';
  el.href = `/assets/${file}`;

  document.head.querySelector('link[rel=stylesheet]')?.insertAdjacentElement('beforebegin', el);

  if (!el.isConnected)
    document.head.querySelector('style')?.insertAdjacentElement('beforebegin', el);

  if (!el.isConnected)
    document.head?.insertAdjacentElement('beforeend', el);
}